import React from 'react';

import {ECheckbox} from '@ELib/components/form/ECheckbox';
import {classy} from '@ELib/utilities/HelperFunctions';

import {
  ListItemWrapper,
  MainElement,
  OptionEndAdornment,
  SideElement,
  TextElements,
} from './EAutocomplete.styles';
import {EAutocompleteCategoriesProps} from './EAutocomplete.types';

export const EAutocompleteCategories = ({
  categories,
  getOptionProps,
  multiple = false,
  onCheckboxClick,
}: EAutocompleteCategoriesProps): React.ReactElement => {
  let index = 0;
  const elements: React.ReactElement[] = [];

  categories.forEach((category, catIndex) => {
    if (category.options.length === 0) {
      return;
    }

    if (categories.length > 1) {
      elements.push(
        <li key={`__section${category.name}`}>
          <ListItemWrapper
            className={classy({
              category: true,
              first: catIndex === 0,
            })}
          >
            <TextElements>
              {category.topLabel ? (
                <SideElement className='category-side'>
                  {category.topLabel}
                </SideElement>
              ) : null}
              {category.mainLabel ? (
                <MainElement className='category-main'>
                  {category.mainLabel}
                </MainElement>
              ) : null}
            </TextElements>
          </ListItemWrapper>
        </li>
      );
    }

    category.options.forEach((option) => {
      elements.push(
        <li
          {...getOptionProps({option, index})}
          key={option.value + index}
          data-id={option.value}
        >
          <ListItemWrapper className='item'>
            {multiple ? (
              <ECheckbox
                value={option.selected}
                sparseGutters
                stopPropagation
                onChange={() => onCheckboxClick(option)}
              />
            ) : null}
            {option.Icon}
            <TextElements>
              <SideElement>{option.titleText || undefined}</SideElement>
              <MainElement className='main'>
                {option.dropdownDisplayText || option.displayText}
              </MainElement>
              <SideElement>{option.subtext || undefined}</SideElement>
            </TextElements>
            <OptionEndAdornment>{option.endAdornment}</OptionEndAdornment>
          </ListItemWrapper>
        </li>
      );

      index++;
    });
  });

  return <>{elements}</>;
};
